<!-- Breadcrumb -->
<!-- <app-breadcrumb></app-breadcrumb> -->
<p-toast></p-toast>

<div class="main">
  <div class="main_dataContainer">
    <!-- Detail page left section (for data preview) -->
    <div class="main_dataContainer_leftBox">
      <button class="back-to-grid-btn" (click)="goBackToGapd()">
        ← Back to Grid View
      </button>
      <!-- Heading Container -->
      <p class="main_dataContainer_leftBox_title">
        {{ detailPageData?.activeIngredientNative }}
      </p>

      <!-- Images Container -->
      <div class="main_dataContainer_leftBox_dataBox">
        <!-- Country Image Box -->
        <div
          class="main_dataContainer_leftBox_dataBox_imgBox ImgageBox"
          *ngIf="this.isShowField('country')"
        >
          <img
            [src]="
              'https://www.chemrobotics.com/agropat/images/flag/' +
              detailPageData?.country +
              '.png'
            "
            alt="Country"
          />
        </div>

        <!-- Chemical Structures Images -->
        <ng-container
          *ngIf="
            detailPageData?.gbrn_products?.length > 0 &&
            this.isShowField('chemicalStructure')
          "
        >
          @for (gbrnProductObj of detailPageData?.gbrn_products; track $index) {
          <div class="main_dataContainer_leftBox_dataBox_imgBox ImgageBox">
            <img
              [src]="
                'https://www.chemrobotics.com/agropat/images/chemical_structure/' +
                gbrnProductObj['chemicalStructure']
              "
              alt="Chemical Structure"
            />
            <app-button1
              class="main_dataContainer_leftBox_dataBox_imgBox_viewBtn"
              buttonText="View"
              (click)="
                showImage(
                  'https://www.chemrobotics.com/agropat/images/chemical_structure/' +
                    gbrnProductObj['chemicalStructure']
                )
              "
            ></app-button1>
          </div>
          }
        </ng-container>

        <!-- Company Image Box -->
        <div
          class="main_dataContainer_leftBox_dataBox_imgBox ImgageBox"
          *ngIf="this.isShowField('productPackageImage')"
        >
          <img
            [src]="
              detailPageData?.productPackageImage
                ? 'https://www.chemrobotics.com/agropat/images/agro_pro_dir/product_image1/' +
                  detailPageData?.productPackageImage
                : 'https://www.chemrobotics.com/assets/images/GAPD-Default-Image.png'
            "
            alt="Company"
          />
        </div>
      </div>

      <!-- Text Container -->
      <div class="main_dataContainer_leftBox_dataBoxSecond">
        @for (section of sectionsItems; track $index) {
        <div
          class="main_dataContainer_leftBox_dataBoxSecond_section"
          *ngIf="!section.isHide"
        >
          <div
            class="main_dataContainer_leftBox_dataBoxSecond_section_header"
            [id]="section.section_id"
          >
            {{ section.section_name }}
          </div>
          <div class="main_dataContainer_leftBox_dataBoxSecond_section_body">
            @for (field of section.fields; track $index) {
            <div
              style="width: 50%"
              class="main_dataContainer_leftBox_dataBoxSecond_section_body_card"
              *ngIf="!field.isHide_field"
            >
              <p class="title">
                <span
                  >{{ getFieldDisplayName(field.field_name)
                  }}<i class="pi pi-copy" (click)="copyToClipboard(field)"></i
                ></span>
              </p>

              <!-- gapd_mongos field data -->
              @if (field) {

              <!-- For normal text -->
              <div
                class="data"
                *ngIf="
                  field.field_name !== 'documents' &&
                  field.field_name !== 'factsheet' &&
                  field.field_name !== 'monograph' &&
                  field.field_name !== 'productArchive' &&
                  field.field_name !== 'regulatoryDocuments' &&
                  field.field_name !== 'mutipleDocuments'
                "
              >
                <ng-container
                  *ngIf="expenedField === field.field_name; else truncatedText"
                >
                  {{ detailPageData[field.field_name] }}
                  <button
                    *ngIf="detailPageData[field.field_name]?.length > 400"
                    class="readMoreBtn"
                    (click)="
                      expenedField =
                        expenedField === field.field_name
                          ? ''
                          : field.field_name
                    "
                  >
                    {{
                      expenedField === field.field_name
                        ? "Read Less"
                        : "Read More"
                    }}
                  </button>
                </ng-container>

                <ng-template #truncatedText>
                  <ng-container
                    *ngIf="detailPageData[field.field_name]?.length <= 400"
                  >
                    {{ detailPageData[field.field_name] }}
                  </ng-container>
                  <ng-container
                    *ngIf="detailPageData[field.field_name]?.length > 400"
                  >
                    {{ detailPageData[field.field_name] | slice : 0 : 400 }}...
                    <button
                      *ngIf="detailPageData[field.field_name]?.length > 400"
                      class="readMoreBtn"
                      (click)="
                        expenedField =
                          expenedField === field.field_name
                            ? ''
                            : field.field_name
                      "
                    >
                      {{
                        expenedField === field.field_name
                          ? "Read Less"
                          : "Read More"
                      }}
                    </button>
                  </ng-container>
                </ng-template>
              </div>

              <!-- For document link -->
              <p
                class="data"
                *ngIf="
                  field.field_name === 'documents' ||
                  field.field_name === 'factsheet' ||
                  field.field_name === 'monograph' ||
                  field.field_name === 'productArchive' ||
                  field.field_name === 'regulatoryDocuments' ||
                  field.field_name === 'mutipleDocuments'
                "
              >
                <ng-container
                  *ngFor="let file of getDocumentList(field.field_name)"
                >
                  <a
                    *ngIf="field.field_name !== 'regulatoryDocuments'"
                    [href]="
                      'https://www.chemrobotics.com/agropat/pdf/gsda/docs/' +
                      file
                    "
                    target="_blank"
                  >
                    {{ file }}
                  </a>
                  <a
                    *ngIf="field.field_name === 'regulatoryDocuments'"
                    [href]="file"
                    target="_blank"
                  >
                    {{ file }}
                  </a>
                  <br />
                </ng-container>
              </p>

              }
              <!-- basic_product_details_MONGO data -->
              @if (field) {
              <div class="data">
                <ul style="padding-left: 1rem">
                  @for (gapdProduct of detailPageData.gbrn_products; track
                  $index) { @if (gapdProduct[field.field_name] &&
                  gapdProduct[field.field_name] !== '') {
                  <li>
                    {{ gapdProduct[field.field_name] }}
                  </li>
                  } }
                </ul>
              </div>
              }
            </div>
            }
          </div>
        </div>
        }
      </div>
    </div>

    <!-- Detail page right section (for sidebar) -->
    <div class="main_dataContainer_rightBox">
      <div class="main_dataContainer_rightBox_sidebar">
        @for (item of sectionsItems; track $index) {
        <div
          class="main_dataContainer_rightBox_sidebar_sidebarEelement"
          [class.active-section]="item.isSelected"
          (click)="openSection(item.section_id)"
          *ngIf="!item.isHide"
        >
          <p>{{ item.section_name }}</p>
        </div>
        }
      </div>
    </div>
  </div>
</div>

<p-dialog
  header="Chemical Structure"
  [(visible)]="display"
  [modal]="true"
  [style]="{ width: 'auto' }"
>
  <div style="display: flex; justify-content: center; align-items: center">
    <img
      [src]="images[0]?.itemImageSrc"
      alt=""
      style="object-fit: contain; max-height: 70vh"
    />
  </div>
</p-dialog>

<!-- Show complete data dialog -->
<p-dialog
  header="Complete Data"
  [(visible)]="isShowReadMoreDetailDialog"
  [modal]="true"
  [style]="{ width: '50vw' }"
>
  <ul>
    <li *ngFor="let data of currReadMoreData">
      {{ data }}
    </li>
  </ul>
  <div *ngIf="currReadMoreData?.length === 0">No data available.</div>
</p-dialog>
